<template>
	<div id="Printouts" class="printouts">
		
		
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'

export default {
	name: 'Printouts',
	mixins: [axiosAction, errors, mixin],
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Centro de Impresión')
			this.setSubTitleModule('')
		},
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>